import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, MapPin } from "lucide-react";
import api from "@/lib/api";
import AIContentBlock from "@/components/AIContentBlock";
import useTranslated from "@/hooks/useTranslated";

export default function Events() {
  const [events, setEvents] = useState([]);
  const descT = useTranslated("events-descriptions", events.map((e) => e.description));

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).catch(console.error);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="events-page">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-slate-500 mb-3">Festivals, Concerts &amp; Events</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-slate-900">Where the World <span className="gradient-text">Gathers to Listen.</span></h1>
      <p className="mt-3 text-slate-600 max-w-2xl">Verified listings from organizers and official sources. Community submissions remain pending until confirmed.</p>

      <AIContentBlock pageKey="events" topic="Music festivals, concerts and live events around the world" imgQuery="music festival stage lights crowd" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
        {events.map((ev, i) => (
          <div key={ev.id} className="card-lift bg-white rounded-3xl border border-slate-100 overflow-hidden flex flex-col sm:flex-row" data-testid={`event-row-${ev.slug}`}>
            <div className="sm:w-48 h-40 sm:h-auto relative shrink-0">
              <img src={ev.image} alt={ev.title} className="w-full h-full object-cover" />
              <div className="absolute top-3 left-3 bg-white rounded-xl shadow-md px-3 py-1.5 text-center">
                <p className="text-[10px] font-black text-pink-600 uppercase">{ev.month}</p>
                <p className="text-lg font-black leading-none text-slate-900">{ev.day}</p>
              </div>
            </div>
            <div className="p-5 flex-1">
              <div className="flex items-center gap-2">
                <Link to={`/events/${ev.slug}`} data-testid={`event-title-link-${ev.slug}`}><h2 className="font-display text-xl font-black text-slate-900 hover:text-pink-600 transition-colors">{ev.title} ›</h2></Link>
                {ev.status === "verified" && <BadgeCheck className="w-4 h-4 text-sky-500" title="Verified by organizer or official source" />}
              </div>
              <p className="text-xs text-slate-500 flex items-center gap-1 mt-1">
                <MapPin className="w-3 h-3 text-pink-500" /> {ev.venue} · {ev.city}, {ev.country}
              </p>
              <p className="text-sm text-slate-600 mt-3">{descT[i] || ev.description}</p>
              <div className="flex flex-wrap gap-1.5 mt-3">
                {ev.tags?.map((t) => <span key={t} className="px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 text-[10px] font-bold">{t}</span>)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
